import { render, staticRenderFns } from "./SamFloatingActions.vue?vue&type=template&id=8b93ab26&scoped=true&shadow"
import script from "./SamFloatingActions.vue?vue&type=script&lang=js&shadow"
export * from "./SamFloatingActions.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamFloatingActions.vue?vue&type=style&index=0&id=8b93ab26&prod&scoped=true&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "8b93ab26",
  null
  ,true
)

export default component.exports